<template>
    <div>
        <select-input
            v-model="value.select"
            :mode="mode"
            :options="options"
            :placeholder="placeholder"
            :appendToBody="appendToBody"
        ></select-input>
        <num-input
            v-if="isVisible"
            v-model="value.payDateXDays"
            class="mt-3"
            mode="edit"
            :controls="true"
        ></num-input>
        <el-checkbox v-model="value.endMonth" class="mt-3">{{
            $l10n.__('En fin de mois')
        }}</el-checkbox>
    </div>
</template>

<script>
import NumInput from 'vcomponents/inputs/NumInput.vue';
import SelectInput from 'vcomponents/inputs/SelectInput.vue';

export default {
    components: {
        NumInput,
        SelectInput,
    },
    props: {
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        mode: {
            type: String,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        // endMonth: {
        //   type: Boolean,
        //     required: false,
        //     default: false
        // },
        // payDateXDays: {
        //     type: Number,
        //     required: false,
        //     default: 0
        // },
        value: {
            type: Object,
            required: false,
            default: {},
        },
        appendToBody: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isVisible: function () {
            var isVisible = false;
            this.options.forEach((option) => {
                if (this.value.select == option.value && option.syscode === 'xdays') {
                    isVisible = true;
                }
            });
            return isVisible;
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.el-input-number span {
    background: $white;
    color: $gray-100;
}
</style>
